import { v4 as uuidv4 } from 'uuid';
/**
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 */
export default function uuid() {
	return uuidv4();
}
